import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const GridStyled = styled(Grid)`
  padding-right: 5px;
`;
